
<div class="countries">
  <h3>Countries we operate in are:</h3>
  <div class="grid">
    <div class="row">
      <ng-container *ngFor="let country of countries">
        <div class="col col-xs-6 col-sm-4 col-lg-3 ion-no-padding" *ngIf="country.active">
          <div class="ion-item ion-align-items-center ion-no-padding">
            <img *ngIf="country.code.length" class="ion-icon ion-margin" src="/assets/flags/{{country.code | lowercase}}.svg" width="32" height="24" loading="lazy"/>
            <img *ngIf="!country.code.length" class="ion-icon ion-margin" src="/assets/flags/{{country.hreflang}}.svg" width="32" height="24" loading="lazy"/>
            <label class="ion-margin">
              <a *ngIf="country.code=='GL'" href="{{'//gigexchange.com'}}"><small>{{country.name}}</small></a>
              <a *ngIf="country.code=='GB'" href="{{'//uk.gigexchange.com'}}"><small>{{country.name}}</small></a>
              <a *ngIf="country.code!=='GL' && country.code!=='GB'" href="{{'//' + country.code + '.gigexchange.com'}}"><small>{{country.name}}</small></a>
              <small *ngIf="!country.code" disabled>{{country.name}}</small>
            </label>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
